/**
 * Posiciona o activator nativo do Shopify Inbox à esquerda do avatar tt-ajuda.
 * Injeta CSS no shadow (position fixed no .activator-nudge).
 */
(function () {
  var CSS =
    '.activator-nudge{' +
    'position:fixed!important;' +
    'right:var(--tt-inbox-dock-right,104px)!important;' +
    'bottom:var(--tt-inbox-dock-bottom,16px)!important;' +
    'left:auto!important;' +
    'top:auto!important;' +
    'opacity:1!important;' +
    'visibility:visible!important;' +
    'pointer-events:auto!important;' +
    'z-index:39!important;' +
    'transform:none!important;' +
    '}' +
    'button.activator,[part~="activator"]{' +
    'pointer-events:auto!important;' +
    'opacity:1!important;' +
    'visibility:visible!important;' +
    '}';

  function paint(host) {
    if (!host || !host.shadowRoot) return;
    var roots = [host.shadowRoot];
    var rt = host.shadowRoot.querySelector('shopify-agent-runtime');
    if (rt && rt.shadowRoot) roots.push(rt.shadowRoot);
    roots.forEach(function (root) {
      var s = root.getElementById('tt-inbox-dock');
      if (!s) {
        s = document.createElement('style');
        s.id = 'tt-inbox-dock';
        root.appendChild(s);
      }
      s.textContent = CSS;
    });
  }

  function syncAjuda(host) {
    var ajuda = document.querySelector('[data-tt-ajuda]');
    if (!ajuda || !host) return;
    var open = host.hasAttribute('open') || host.getAttribute('is-open') === 'true';
    if (open) ajuda.classList.add('is-chat-open');
    else ajuda.classList.remove('is-chat-open');
  }

  function tick() {
    var host =
      document.querySelector('shopify-chat') ||
      document.querySelector('inbox-online-store-chat');
    if (!host) return;
    paint(host);
    syncAjuda(host);
  }

  tick();
  new MutationObserver(tick).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['open', 'is-open']
  });

  // Reaplica se o shadow remontar
  setInterval(tick, 2000);
})();
